import React from 'react';
import './promotion-tag.scss';
import { getPromotionDetails } from '../../helper';

interface PromotionTagProps {
  promotionType: string;
  promotion?: string;
  minQtyASC?: number;
  freeQtyASC?: number;
}

export const PromotionTag: React.FC<PromotionTagProps> = ({
  promotionType,
  promotion,
  minQtyASC,
  freeQtyASC,
}) => {
  const { icon, text, textColor } = getPromotionDetails(
    promotionType,
    minQtyASC,
    freeQtyASC,
    parseFloat(promotion || '0')
  );

  return (
    <div className="promotion-tag-view">
      <img src={icon} width={16} height={16} />
      <span className={`promotion-tag-view-text font-medium ${textColor}`}>
        {text}
      </span>
    </div>
  );
};
